import { MakeApiCallAsync } from './ApiHelpers';
import Config from './Config';
import { filterProductsByDeliveryLocation } from './LocationHelper';

export const categoryHasProducts = async (categoryId, isCancelled = () => false) => {
    const pageSize = 100;
    for (let pageNo = 1; !isCancelled(); pageNo += 1) {
        const response = await MakeApiCallAsync(Config.END_POINT_NAMES.GET_All_PRODUCTS, null,
            { requestParameters: { CategoryID: categoryId, PageNo: pageNo, PageSize: pageSize, recordValueJson: '[]' } },
            { Accept: 'application/json', 'Content-Type': 'application/json' }, 'POST', true);
        if (!response?.data?.data) throw new Error('Unable to check category products');
        const products = JSON.parse(response.data.data);
        if (!Array.isArray(products)) throw new Error('Invalid category products response');
        if (filterProductsByDeliveryLocation(products).length > 0) return true;
        const totalRecords = Number(products[0]?.TotalRecords);
        if (products.length < pageSize || (Number.isFinite(totalRecords) && totalRecords > 0 && pageNo * pageSize >= totalRecords)) return false;
    }
    return false;
};

export const filterCategoriesWithProducts = async (categories, isCancelled = () => false) => {
    const available = new Array(categories.length).fill(false);
    let nextIndex = 0;
    const worker = async () => {
        while (nextIndex < categories.length && !isCancelled()) {
            const index = nextIndex++;
            try {
                available[index] = await categoryHasProducts(categories[index].CategoryID, isCancelled);
            } catch (error) {
                // Keep the category visible when availability cannot be verified.
                available[index] = true;
                console.error('Unable to check category availability', error);
            }
        }
    };
    await Promise.all(Array.from({ length: Math.min(4, categories.length) }, worker));
    return categories.filter((_, index) => available[index]);
};
